const KEYBOARD = {
    ENTER: "Enter"
}
export default KEYBOARD;